'use client';
import { Box, AppBar, Toolbar, useTheme, useMediaQuery } from '@mui/material';
import Theme from '../components/Theme';

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <html lang='en'>
      <body>
        <Theme>
          <Box
            sx={{
              display: 'flex',
              maxHeight: '100vh',
              width: '100%',
              flexDirection: isMobile ? 'column' : 'row',
              overflowY: 'auto',
            }}
          >
            {/* NAVBAR */}
            <AppBar
              position='fixed'
              sx={{
                zIndex: (t) => t.zIndex.drawer + 1,
                backgroundColor: '#f7f4f2',
                boxShadow: 'none',
                borderBottom: 'none',
                height: '85px',
              }}
            >
              <Toolbar
                disableGutters
                sx={{
                  height: '85px',
                  minHeight: '85px',
                  borderBottom: 'none',
                  boxShadow: 'none',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    pl: '12px',
                  }}
                >
                  <a href='https://argos.fastcomputing.net'>
                    <img
                      src='/static/images/logo-argos.png'
                      alt='ARGOS logo'
                      style={{
                        height: '40px',
                        width: 'auto',
                        display: 'block',
                        marginLeft: '15vw',
                      }}
                    />
                  </a>
                </Box>
              </Toolbar>
            </AppBar>
            {children}
          </Box>
        </Theme>
      </body>
    </html>
  );
}
